enum LimitedFoodGatheringSourceModifierId {
    TWIN_MINARET_MEDRESE = 'TWIN_MINARET_MEDRESE'
}

export default LimitedFoodGatheringSourceModifierId

